import React, { Component } from 'react'
import { connect } from 'react-redux'
//import { Card, Table } from 'react-bootstrap'
//import { FaDesktop, FaMobileAlt } from 'react-icons/fa'
import { withRouter } from 'react-router-dom';
import Tooltip from './common/popover/tooltip'
import { formatDetectionDatetime } from '../utilities/datetime'
import UpdatePopover from './common/popover/updatePopover'
import EnterIcon from '../assets/Enter_Arrow_Right.svg'
import './ThreatIntelList.scss'

import { loadThreatIntel } from '../store/entities/threatintel'

class ThreatIntelList extends Component {
    constructor(props) {
        super(props)
    }

    // onDetails = (item) => {
    //         this.props.history.push(`/threat-intel-feed/${item.id}`);
    // };

    render() {
        const { events , isLastPage, displaySize, pageNo, tokenRoles, onDetails, showUpdatePopover} = this.props;
        
        return (
            <>
            <div className="pageContainer">
            <div style={{ minWidth: '290px' }}>
                <b>
                Results (
                {((pageNo - 1) * displaySize) + events.length}
                {isLastPage ? '' : `+`}
                )
                </b>
            </div>
            <table className="listTable mb-5">
                <thead className="tableHead">
                <tr></tr>
                <tr>
                <th style={{ minWidth: '160px' }}>Brand</th>
                <th style={{ minWidth: '350px' }}>URL</th>
                <th style={{ minWidth: '180px' }}>Open At</th>
                <th style={{ minWidth: '170px' }}>Status</th>
                <th style={{ minWidth: '50px' }}></th>
                </tr>
                </thead>
                <tbody>
                {events.map((item, index) => (
                <tr key={item.id}>
                <td style={{ minWidth: '160px' }}>
                    <span style={{ color: '#2d5fa7' }}>
                    <b>{item.detectedBrands || "NA"}</b>
                    </span>
                </td>
                <td style={{ minWidth: '350px' }}>
                    <div
                    className="textWrap urlWrap"
                    data-tip
                    data-for={item.threatURL}
                    >
                    {item.threatURL || "NA"}
                    </div>
                    <Tooltip id={item.threatURL} data={item.threatURL} />
                </td>
                <td style={{ minWidth: '180px' }}>
                <div className="textWrap">
                    <span>
                    <i>
                    {/* Opened at{' '} */}
                    {formatDetectionDatetime(item.threatDetectedOn)}
                    </i>
                    </span>
                    </div>
                </td>
                <td style={{ minWidth: '120px' }}>
                    <span className={item.isVerified ? "pixmVerifiedText" : "AI Suspicious"}>
                    <b>{item.isVerified ? "PIXM Verified" : "AI Suspicious"}</b>
                    </span>
                    { showUpdatePopover &&
                    <UpdatePopover
                    {...this.props}
                    role={tokenRoles}
                    event={item}
                    from={"ThreatIntelList"}
                    />
                    }
                </td>
                <td style={{ minWidth: '30px' }}>
                    <img
                    className="rowDetail"
                    onClick={() => onDetails(item)}
                    src={EnterIcon}
                    alt="next-icon"
                    />
                </td>
                </tr>
                ))}
                </tbody>
            </table>
            </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    events: state.entities.threatintel.events,
    pageSize: state.entities.threatintel.pageSize,
    filters: state.entities.threatintel.filters,
    sorting: state.entities.threatintel.sorting,
    isLastPage: state.entities.threatintel.isLastPage,
    displaySize: state.entities.threatintel.displaySize,
})

const mapDispatchToProps = (dispatch) => ({
    loadThreatIntel: (filters, sorting, pageNo, pageSize) => dispatch(loadThreatIntel(filters, sorting, pageNo, pageSize)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ThreatIntelList))
